import styled from "styled-components";

export const StyledLi = styled.li`
	width: calc((100% - 100px) / 6);
	transition: 0.5s;

	@media (max-width: 650px) {
		width: calc((100% - 40px) / 3);
	}

	cursor: pointer;

	svg {
		width: 100%;
		height: auto;
	}

	p {
		font-size: 20px;
		color: var(--orange);
		text-shadow: var(--textShadowBlack);
		text-align: center;
	}

	&:hover {
		color: var(--blue50);
		-webkit-filter: drop-shadow(5px 5px 5px #222);
		filter: drop-shadow(5px 5px 5px #222);
		p {
		}
	}
`;
